import { Injectable } from '@angular/core';
import { ListFilters, UrlCodecs } from 'src/app/shared/ExtendedListService';
import type { GetCourseListDto } from '@proxy/courses';

/**
 * Declares which GetCourseListDto keys are persisted in the URL and how.
 * TenantCourseService's DTO (GetTenantCourseListDto) doesn't have creatorId -
 * it's only sent to CoursesService, same as before this conversion.
 */
@Injectable()
export class CoursesFilters extends ListFilters<GetCourseListDto> {
  readonly schema = {
    categoryId: UrlCodecs.string,
    testId: UrlCodecs.string,
    availableUntil: UrlCodecs.isoDateString,
    creationDateFrom: UrlCodecs.isoDateString,
    creationDateTo: UrlCodecs.isoDateString,
    creatorId: UrlCodecs.string,
  };
}
